/**
 * Publish routes — lazy-loaded stubs for all category publish screens.
 *
 * These are integrated into the main router under the /app auth-guarded tree.
 * Each screen is its own JS chunk (lazy import) so the initial bundle stays lean.
 *
 * Route tree:
 *   /app/publish              → PublishCategoryPicker  (choose a category)
 *   /app/publish/news         → PublishNewsScreen
 *   /app/publish/good-plan    → PublishGoodPlanScreen
 *   /app/publish/job          → PublishJobScreen
 *   /app/publish/event        → PublishEventScreen
 *   /app/publish/music        → PublishMusicScreen
 *   /app/publish/misc         → PublishMiscScreen
 *
 * Full implementation of each screen is scoped to Group D.
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const PublishCategoryPicker = lazy(() =>
  import('./screens/PublishCategoryPicker').then((m) => ({
    default: m.PublishCategoryPicker,
  })),
);
const PublishNewsScreen = lazy(() =>
  import('./screens/PublishNewsScreen').then((m) => ({
    default: m.PublishNewsScreen,
  })),
);
const PublishGoodPlanScreen = lazy(() =>
  import('./screens/PublishGoodPlanScreen').then((m) => ({
    default: m.PublishGoodPlanScreen,
  })),
);
const PublishJobScreen = lazy(() =>
  import('./screens/PublishJobScreen').then((m) => ({
    default: m.PublishJobScreen,
  })),
);
const PublishEventScreen = lazy(() =>
  import('./screens/PublishEventScreen').then((m) => ({
    default: m.PublishEventScreen,
  })),
);
const PublishMusicScreen = lazy(() =>
  import('./screens/PublishMusicScreen').then((m) => ({
    default: m.PublishMusicScreen,
  })),
);
const PublishMiscScreen = lazy(() =>
  import('./screens/PublishMiscScreen').then((m) => ({
    default: m.PublishMiscScreen,
  })),
);

export const publishRoutes: RouteObject[] = [
  { path: 'publish', element: <PublishCategoryPicker /> },
  { path: 'publish/news', element: <PublishNewsScreen /> },
  { path: 'publish/good-plan', element: <PublishGoodPlanScreen /> },
  { path: 'publish/job', element: <PublishJobScreen /> },
  { path: 'publish/event', element: <PublishEventScreen /> },
  { path: 'publish/music', element: <PublishMusicScreen /> },
  { path: 'publish/misc', element: <PublishMiscScreen /> },
];
